export default __webpack_public_path__ + "static/media/WIP.81abea59.svg";